import accounting from 'accounting'

const filter = (valor, prefixo, quantidadeCasasDecimais) => {
    if ((valor === null || valor === undefined) || !quantidadeCasasDecimais) {
        return '--'
    }
    return accounting.formatMoney(valor, prefixo, quantidadeCasasDecimais, '.', ',')
}

export default filter
